import { Link } from "react-router-dom";
import Reveal from "./Reveal";

interface ClosingCTAProps {
  link: string;
}

const ClosingCTA = ({ link }: ClosingCTAProps) => {
  return (
    <Reveal className="mx-auto mb-24 flex w-full max-w-2xl flex-col items-center px-4 text-center">
      <p className="text-[22px] font-bold leading-snug text-white max-sm:text-[18px]">
        With Pay-Per-View, you're in control of your content and your
        earnings. Start monetizing your live videos and events today, and
        unleash your creative potential.
      </p>
      <Link to={link}>
        <button className="mt-8 rounded-full bg-[var(--red)] px-9 py-3.5 text-[15px] font-bold text-white shadow-lg shadow-[var(--red)]/30 transition-all duration-300 hover:scale-[1.03] hover:brightness-110 hover:shadow-xl">
          Explore Content
        </button>
      </Link>
    </Reveal>
  );
};

export default ClosingCTA;
